import { inject } from '@angular/core';
import type { Country } from '@indutrust/shared-model';
import {
  entitiesOrderedAsSelectOptionComputed,
  withCrudEntitiesEvents,
  withLoadAllOnAuthEvents,
  withOrderedEntities,
} from '@indutrust/shared-util';
import { signalStore, withComputed } from '@ngrx/signals';
import { CountryApiClient } from '../country-api-client.service';
import { countryCrudEvents } from './country.events';

/**
 * Signal store managing the collection and selection of Country entities.
 *
 * Provides ordered entities, selection helpers, and event-driven CRUD operations via {@link withCrudEntitiesEvents}.
 * API calls are automatically handled through the service factory passed to withCrudEntitiesEvents.
 *
 */
export const CountryStore = signalStore(
  { providedIn: 'root' },
  withCrudEntitiesEvents<Country>(countryCrudEvents, () =>
    inject(CountryApiClient)
  ),
  withLoadAllOnAuthEvents(countryCrudEvents),
  withOrderedEntities<Country>(),
  withComputed(entitiesOrderedAsSelectOptionComputed<Country>())
);
